import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Cosmetics = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-button:focus {
                box-shadow: none;
                border-color: rgba(0,0,0,.125);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
        </style>

        <div id="wrapper">
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                            <h2 class="display-3 fw-bold color all-ts">Cosmetics</h2>
                            <p>Discover our premium range of cosmetic products</p>
                        </div>
                        <div class="col-lg-6">
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Image" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="content">
                <div class="content-wrap py-0">
                    <div id="products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Our Cosmetic Range</h2>
                                    <p>Premium quality cosmetic products for your beauty needs</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <!-- FACE WASH -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faceWash">
                                                    <i class="bi bi-droplet me-2"></i>FACE WASH
                                                </button>
                                            </h2>
                                            <div id="faceWash" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Neem Extract with Lemon Extract Face Wash</td></tr>
                                                                <tr><td>Orange Extract Face Wash</td></tr>
                                                                <tr><td>Olive Oil Face Wash</td></tr>
                                                                <tr><td>Pimple care Face Wash with Tea Tree Oil and Triclosan</td></tr>
                                                                <tr><td>Pimple care Face Wash with Tea Tree Oil and Salicylic Acid</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Glycolic Acid – 3%</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Glycolic Acid – 6%</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Liquorice Extract, Lactic Acid, Glycolic Acid</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Glutathione</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- GEL BASE FACE WASH -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#gelFaceWash">
                                                    <i class="bi bi-droplet me-2"></i>GEL BASE FACE WASH WITH MILLIGLOBULES (LIPO BEEDS)
                                                </button>
                                            </h2>
                                            <div id="gelFaceWash" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Pimple care Face Wash with Tea Tree Oil and Triclosan</td></tr>
                                                                <tr><td>Pimple care Face Wash with Tea Tree Oil and Salicylic Acid</td></tr>
                                                                <tr><td>Pimple care Face Wash with Tea Tree Oil, Salicylic Acid, Triclosan, Vitamin-E</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Glycolic Acid – 3%</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Glycolic Acid – 6%</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Liquorice Extract, Lactic Acid, Glycolic Acid</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Glycolic Acid, Niacinamide</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- CREAM BASE FACE WASH -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#creamFaceWash">
                                                    <i class="bi bi-droplet me-2"></i>CREAM BASE FACE WASH WITH MILLIGLOBULES (LIPO BEEDS)
                                                </button>
                                            </h2>
                                            <div id="creamFaceWash" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Pimple care Face Wash with Tea Tree Oil and Triclosan</td></tr>
                                                                <tr><td>Pimple care Face Wash with Tea Tree Oil and Salicylic Acid</td></tr>
                                                                <tr><td>Skin Whitening Face Wash with Kojic Acid, Nicotinamide, Liquorice Extract, Vitamin-E, Mulberry Extract, Black Pepper Extract</td></tr>
                                                                <tr><td>Oil Control Face Wash in Cream Base for Oily and Acne Prone Skin</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- MOISTURISING CREAM -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#moisturisingCream">
                                                    <i class="bi bi-droplet me-2"></i>MOISTURISING CREAM
                                                </button>
                                            </h2>
                                            <div id="moisturisingCream" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>White Soft Paraffin and Light Liquid Paraffin</td></tr>
                                                                <tr><td>Glycerine, LLP, Wheat Germ Oil, Calendula Extract</td></tr>
                                                                <tr><td>Vitamin-E, Bees Wax, Aloevera, Hard Paraffin Wax</td></tr>
                                                                <tr><td>Vitamin-E, Squelene and Zemea Propanediol</td></tr>
                                                                <tr><td>Calendula Extract, Petroleum Jelly, Peach Fruit Extract, Zemea Propanediol</td></tr>
                                                                <tr><td>Mulberry Extract, Aloevera, Bearberries Extract</td></tr>
                                                                <tr><td>Shea Butter & Cocoa Butter</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SKIN WHITENING CREAM -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#skinWhiteningCream">
                                                    <i class="bi bi-droplet me-2"></i>SKIN WHITENING CREAM
                                                </button>
                                            </h2>
                                            <div id="skinWhiteningCream" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Skin Whitening Cream with Liquorice Extract 40% CA and Niacinamide</td></tr>
                                                                <tr><td>Skin Whitening Cream with Arbutin, Wheat germ Oil and OMC</td></tr>
                                                                <tr><td>Skin Whitening Cream with Wheat germ Oil, Bearberries and Arbutin</td></tr>
                                                                <tr><td>Skin Whitening Cream with Glutathione</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SUN SCREEN -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sunScreen">
                                                    <i class="bi bi-sun me-2"></i>SUN SCREEN
                                                </button>
                                            </h2>
                                            <div id="sunScreen" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>TYPE</th>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Lotion Base</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>SPF 30 with OMC, Avobenzene, and Titanium Dioxide</li>
                                                                            <li>SPF 35 with OMC, Avobenzene and Oxybenzone</li>
                                                                            <li>SPF 40 with OMC, Avobenzene, Oxybenzone, Titanium Dioxide, and Zinc Oxide</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Gel Base</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>SPF 30 with OMC, Avobenzene, Aloevera and Titanium Dioxide</li>
                                                                            <li>SPF 35 with OMC, Avobenzene and Oxybenzone</li>
                                                                            <li>SPF 40 with OMC, Avobenzene, Oxybenzone, Titanium Dioxide, Aloe & Zinc Oxide</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- MOISTURISING LOTION -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#moisturisingLotion">
                                                    <i class="bi bi-droplet me-2"></i>MOISTURISING LOTION
                                                </button>
                                            </h2>
                                            <div id="moisturisingLotion" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Peach Extract and Jojoba Oil</td></tr>
                                                                <tr><td>White Soft Paraffin and Light Liquid Paraffin</td></tr>
                                                                <tr><td>Glycerine, LLP, Wheat Germ Oil, Calendula Extract</td></tr>
                                                                <tr><td>Vitamin-E, Bees Wax, Aloevera, Hard Paraffin Wax</td></tr>
                                                                <tr><td>Vitamin-E, Squelene and Zemea Propanediol</td></tr>
                                                                <tr><td>Shea Butter & Cocoa Butter</td></tr>
                                                                <tr><td>Moisturising Lotion with Sea Minerals</td></tr>
                                                                <tr><td>Moisturising Lotion with Argan Oil</td></tr>
                                                                <tr><td>Calendula Extract, Peach Fruit Extract, Zemea Propanediol</td></tr>
                                                                <tr><td>Mulberry Extract, Aloevera, Bearberries Extract</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SKIN WHITENING LOTION -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#skinWhiteningLotion">
                                                    <i class="bi bi-droplet me-2"></i>SKIN WHITENING LOTION
                                                </button>
                                            </h2>
                                            <div id="skinWhiteningLotion" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Skin Whitening Lotion with Niacinamide, Arbutin, Wheat germ Oil and OMC</td></tr>
                                                                <tr><td>Skin Whitening Lotion with Kojic Acid, Turmeric Extract, Nicotinamide, Liqourice Extract, Arbutin, Glycolic Acid, Lactic Acid, Vitamin-C, Chandan, Titanium Dioxide, Wheat Germ Oil and Carrot Oil</td></tr>
                                                                <tr><td>Skin Whitening Lotion with Glutathione</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- FACE PACK -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#facePack">
                                                    <i class="bi bi-droplet me-2"></i>FACE PACK
                                                </button>
                                            </h2>
                                            <div id="facePack" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Pimple Care Face Pack with Tea Tree Oil, Aloevera, Triclosan</td></tr>
                                                                <tr><td>Tightening Face Pack with Aloevera, Cucumber Juice and Lemon Extract</td></tr>
                                                                <tr><td>Anti Septic Face Pack with Neem Chhal Powder and Lemon Extract</td></tr>
                                                                <tr><td>Fairness Face Pack with Lemon Extract, Wheat Germ Oil and Liquorice Extract</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- CLEANSING MILK -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#cleansingMilk">
                                                    <i class="bi bi-droplet me-2"></i>CLEANSING MILK
                                                </button>
                                            </h2>
                                            <div id="cleansingMilk" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Cleansing Milk with Lemon Extract and Cucumber Juice</td></tr>
                                                                <tr><td>Cleansing Milk with Aloevera and Rose Petal Extract</td></tr>
                                                                <tr><td>Cleansing Milk with Shea Butter and Cocum Butter</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SCRUBS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#scrubs">
                                                    <i class="bi bi-droplet me-2"></i>SCRUBS
                                                </button>
                                            </h2>
                                            <div id="scrubs" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Walnut & Apricoat Scrub</td></tr>
                                                                <tr><td>Walnut & Grape Seed Oil Scrub</td></tr>
                                                                <tr><td>Chocolate Scrub</td></tr>
                                                                <tr><td>Neem & Lemon Extract Scrub</td></tr>
                                                                <tr><td>Aloevera and Tulsi Scrub</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- PEEL OFF MASK -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#peelOffMask">
                                                    <i class="bi bi-droplet me-2"></i>PEEL OFF MASK
                                                </button>
                                            </h2>
                                            <div id="peelOffMask" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Orange Peel Extract and Lemon Extract Peel off Mask</td></tr>
                                                                <tr><td>Insta-Glow Peel off Mask with Orange Peel Extract and Golden Glitters</td></tr>
                                                                <tr><td>Peel off Mask with Grape Seed Oil and Jojoba Oil</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- VAGINAL WASH -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#vaginalWash">
                                                    <i class="bi bi-droplet me-2"></i>VAGINAL WASH / LIQUID (pH Balanced)
                                                </button>
                                            </h2>
                                            <div id="vaginalWash" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Vaginal Hygiene Wash with Lactic Acid and Neem and Vitamin-E</td></tr>
                                                                <tr><td>Vaginal Hygiene Wash with Lactic Acid and Aloevera and Mushroom Extract</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- HAIR SERUM -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#hairSerum">
                                                    <i class="bi bi-droplet me-2"></i>HAIR SERUM
                                                </button>
                                            </h2>
                                            <div id="hairSerum" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Wheat Germ Oil and Grape Seed Oil Hair Serum</td></tr>
                                                                <tr><td>Silicon Oil with Dimethicone Hair Serum</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- SHAMPOO -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#shampoo">
                                                    <i class="bi bi-droplet me-2"></i>SHAMPOO
                                                </button>
                                            </h2>
                                            <div id="shampoo" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Dandruff Control Shampoo with Piroctone Olamine and Jojoba Oil</td></tr>
                                                                <tr><td>Hair fall Control Shampoo with Niacinamide, Soyabean Extract, Wheat Protein Extract, Vitamin-E, and Grape Seed Oil</td></tr>
                                                                <tr><td>Conditioning Shampoo with Polyquartenium 10, Symethicon, Hydroxy Ethyl Urea</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- CONDITIONER -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#conditioner">
                                                    <i class="bi bi-droplet me-2"></i>CONDITIONER
                                                </button>
                                            </h2>
                                            <div id="conditioner" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>PRODUCT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>Dandruff Control Conditioner with Piroctone Olamine and Jojoba Oil</td></tr>
                                                                <tr><td>Hair fall Control Conditioner with Niacinamide, Soyabean Extract, Wheat Protein Extract, Vitamin-E, and Grape Seed Oil</td></tr>
                                                                <tr><td>Heavy Moist Conditioner - Polyquartenium-10, Simethicone, Hydroxy Ethyl Urea</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- AYURVEDIC PRODUCTS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#ayurvedic">
                                                    <i class="bi bi-droplet me-2"></i>AYURVEDIC PRODUCTS
                                                </button>
                                            </h2>
                                            <div id="ayurvedic" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>CATEGORY</th>
                                                                    <th>PRODUCTS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Face Wash</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Azadirachta Indica Face Wash (Neem Leaf)</li>
                                                                            <li>Citrus Oransieaum Face Wash (Orange)</li>
                                                                            <li>Pimple care Face Wash with Melaleuca alternifolia (Tea Tree Oil)</li>
                                                                            <li>Skin Whitening with Rosa Centifolia & Citrus Acida (Rose Petal & Lemon)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Gel Base Face Wash</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Azadirachta Indica Face Wash (Neem Leaf)</li>
                                                                            <li>Citrus Oransieaum Face Wash (Orange)</li>
                                                                            <li>Pimple care Face Wash with Melaleuca alternifolia (Tea Tree Oil)</li>
                                                                            <li>Skin Whitening with Rosa Centifolia & Citrus Acida (Rose Petal & Lemon)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Moisturising Cream</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Moisturising Cream with Aloe Barbadensis (Aloevera)</li>
                                                                            <li>Moisturising Cream with Aloe Barbadensis & Triticum Valgare (Aloevera & Wheat Germ Oil)</li>
                                                                            <li>Moisturising Cream with Aloe Barbadensis, Simmondsia Chinensis & Calendula Officinalis (Aloevera, Jojoba Oil & Calendula Extract)</li>
                                                                            <li>Moisturising Cream with Tagetes Lucida (Merigold Extract)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Moisturising Lotion</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Moisturising Lotion with Prunus Persica & Simmondsia Chinensis (Peach Extract & Jojoba Oil)</li>
                                                                            <li>Moisturising Lotion with Aloe Barbadensis, Triticum Valgare & Calendula Officinalis (Aloevera, Wheat Germ Oil, Calendula Extract)</li>
                                                                            <li>Moisturising Lotion with Tagetes Lucida (Merigold Extract)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Skin Whitening Lotion</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Skin Whitening Lotion with Curcuma Longa, Glycyrrhiza glabra, Santalum album, Triticum Valgare, Daucus carota (Turmeric Extract, Liqourice Extract, Chandan, Wheat Germ Oil and Carrot Oil)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Face Pack</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Pimple Care Face Pack with Melaleuca alternifolia, Aloe Barbadensis & Azadirachta Indica (Tea Tree Oil, Aloevera & Neem Leaf)</li>
                                                                            <li>Tightening Face Pack with Aloe Barbadensis, Cucumis sativus & Citrus Oransieaum (Aloevera, Cucumber Juice and Lemon Extract)</li>
                                                                            <li>Anti Septic Face Pack with Azadirachta Indica & Citrus Oransieaum (Neem Chhal Powder & Lemon Peel)</li>
                                                                            <li>Fairness Face Pack with Citrus Oransieaum, Triticum Valgare & Glycyrrhiza glabra (Lemon Extract, Wheat Germ Oil & Liquorice Extract)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Scrubs</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Alluraeti traibola & Prunus armeniaca Scrub (Walnut & Apricoat)</li>
                                                                            <li>Alluraeti traibola & Vitis Vinifera Scrub (Walnut & Grape Seed Oil)</li>
                                                                            <li>Azadirachta Indica & Citrus Oransieaum Scrub (Neem Leaf & Lemon Peel Extract)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Shampoo</td>
                                                                    <td>
                                                                        <ul>
                                                                            <li>Dandruff Control Shampoo with Azadirachta indica, Eclipta prostrate & Annona squamosal (Neem Fruit Oil, Bhringraj & Sitafal Beej)</li>
                                                                            <li>Hair fall Control Shampoo with Phyllanthus Embelica, Acacia concinna, Sapindus laurifolia & Lawsania alba (Amla, Shikakai, Ariha & Mehandi)</li>
                                                                            <li>Conditioning Shampoo with Phyllanthus Embelica, Sapindus laurifolia, Olea europaea, Lawsania alba, Lagenaria siceraria & Cyperus scariosus (Amla, Aritha, Olive Oil, Mehandi, Dudhi, Nagarmoth &Glycerine)</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default Cosmetics; 